var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3633 0H2.63672C1.18295 0 0 1.18295 0 2.63672V15.3633C0 16.817 1.18295 18 2.63672 18H15.3633C16.817 18 18 16.817 18 15.3633V2.63672C18 1.18295 16.817 0 15.3633 0ZM9.03516 13.7109C6.41808 13.7109 4.28906 11.5819 4.28906 8.96484C4.28906 6.34776 6.41808 4.21875 9.03516 4.21875C11.6522 4.21875 13.7812 6.34776 13.7812 8.96484C13.7812 11.5819 11.6522 13.7109 9.03516 13.7109ZM14.3086 5.27344C13.4363 5.27344 12.7266 4.56372 12.7266 3.69141C12.7266 2.81909 13.4363 2.10938 14.3086 2.10938C15.1809 2.10938 15.8906 2.81909 15.8906 3.69141C15.8906 4.56372 15.1809 5.27344 14.3086 5.27344Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3086 3.16406C14.0176 3.16406 13.7812 3.40041 13.7812 3.69141C13.7812 3.98241 14.0176 4.21875 14.3086 4.21875C14.5996 4.21875 14.8359 3.98241 14.8359 3.69141C14.8359 3.40041 14.5996 3.16406 14.3086 3.16406Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03516 5.27344C6.99994 5.27344 5.34375 6.92963 5.34375 8.96484C5.34375 11.0001 6.99994 12.6562 9.03516 12.6562C11.0704 12.6562 12.7266 11.0001 12.7266 8.96484C12.7266 6.92963 11.0704 5.27344 9.03516 5.27344Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.27962d28.svg";
export { ForwardRef as ReactComponent };